import { getIn, FormikProps } from "formik"
import { convertNumeralToFloatString } from "../general"
import { Field } from "./types"

export const handleIsRequired = (inputField: Field, formik: FormikProps<unknown>, fieldName: string) => {
    if (inputField.required) return true
    if (inputField.isRequired) {
        return inputField.isRequired(formik, fieldName)
    }
    return false
}

export const calculatePriceM2 = <T>(formik: FormikProps<T>, updatedPrice?: string, updatedArea?: string): string => {
    // updated value (by user) ?? existing value (formik)
    const price = updatedPrice ?? getIn(formik.values, 'general.price')
    const area = updatedArea ?? getIn(formik.values, 'general.area')

    if (!price || !area) return ''

    const parsedPrice = parseFloat(convertNumeralToFloatString(price))
    const parsedArea = parseFloat(convertNumeralToFloatString(area))

    if (isNaN(parsedPrice) || isNaN(parsedArea) || parsedArea === 0) return ''

    const calculatedM2 = (parsedPrice / parsedArea).toFixed(2)
    return calculatedM2.toString().replace(/\./g, ',')
}
